import React from 'react';
import {Button} from 'material-ui';

export const SaveButton = (props) => {

    const {
        type,
        disabled,
        loading,
        variant,
        color,
        className,
        onClick
    } = props;

    return (
        <Button
            type={type}
            disabled={disabled}
            variant={variant}
            color={color}
            className={className}
            onClick={onClick}
        >
            {loading ? 'Saving...' : 'Save'}
        </Button>
    )
}


// WEBPACK FOOTER //
// ./src/components/buttons/SaveButton.jsx